<template>
  <div>
    <configured-property
      v-for="(property) in supportedProperties"
      :key="property.key"
      :label="property.label"
      :placeholder="property.placeholder"
      :property-key="property.key"
      :property-value="property.value"
      :is-sensitive="property.isSensitive"
      @on-edit="updateProperty(property, $event)"
      @on-delete="deleteProperty(property)"
    />
  </div>
</template>
<script>
import ConfiguredProperty from './ConfiguredProperty'
import { dataAPI } from '../services/DataAPI'

export default {
  components: { ConfiguredProperty },
  data() {
    return {
      supportedProperties: {
        WSG_URL: {
          key: 'WSG_URL',
          label: 'WSG URL',
          placeholder: 'Base URL for the WSG to use',
          value: ''
        },
        WSG_USERNAME: {
          key: 'WSG_USERNAME',
          label: 'WSG Username',
          placeholder: 'Username to use for authentication with WSG',
          value: ''
        },
        WSG_PASSWORD: {
          key: 'WSG_PASSWORD',
          label: 'WSG Password',
          placeholder: 'Password to use for authentication with WSG',
          value: '',
          isSensitive: true
        },
        WSG_WALLET_USERNAME: {
          key: 'WSG_WALLET_USERNAME',
          label: 'WSG Wallet Username',
          placeholder: 'Username to use for authentication with WSG for wallet calls',
          value: ''
        },
        WSG_WALLET_PASSWORD: {
          key: 'WSG_WALLET_PASSWORD',
          label: 'WSG Wallet Password',
          placeholder: 'Password to use for authentication with WSG for wallet calls',
          value: '',
          isSensitive: true
        },
        PAYMENT_SERVICE_URL: {
          key: 'PAYMENT_SERVICE_URL',
          label: 'Payment Service URL',
          placeholder: 'Base URL for the Payment Service to use',
          value: ''
        },
        PAYMENT_SERVICE_USERNAME: {
          key: 'PAYMENT_SERVICE_USERNAME',
          label: 'Payment Service Username',
          placeholder: 'Username to use for authentication with Payment Service',
          value: ''
        },
        PAYMENT_SERVICE_PASSWORD: {
          key: 'PAYMENT_SERVICE_PASSWORD',
          label: 'Payment Service Password',
          placeholder: 'Password to use for authentication with Payment Service',
          value: '',
          isSensitive: true
        },
        IP_BLACKLIST_AUTHORIZATION_FAILED_THRESHOLD: {
          key: 'IP_BLACKLIST_AUTHORIZATION_FAILED_THRESHOLD',
          label: 'IP Blacklist Threshold',
          placeholder: 'Failures required for an IP to be blacklisted',
          value: ''
        },
        IP_BLACKLIST_AUTHORIZATION_FAILED_FALLOFF: {
          key: 'IP_BLACKLIST_AUTHORIZATION_FAILED_FALLOFF',
          label: 'IP Blacklist Falloff',
          placeholder: 'Time in seconds before a failure is forgotten',
          value: ''
        },
        IP_BLACKLIST_AUTHORIZATION_BLACKLIST_PERIOD: {
          key: 'IP_BLACKLIST_AUTHORIZATION_BLACKLIST_PERIOD',
          label: 'IP Blacklist Period',
          placeholder: 'Time in seconds to blacklist an IP when they reach the threshold',
          value: ''
        },
        IP_BLACKLIST_AUTHORIZATION_BLACKLIST_QUIET_PERIOD: {
          key: 'IP_BLACKLIST_AUTHORIZATION_BLACKLIST_QUIET_PERIOD',
          label: 'IP Blacklist Quiet Period',
          placeholder: 'Time in seconds to extend a blacklist when the IP is still making requests',
          value: ''
        },
        RECAPTCHA_PROJECT_ID: {
          key: 'RECAPTCHA_PROJECT_ID',
          label: 'reCAPTCHA Project ID',
          placeholder: 'Enterprise reCAPTCHA Project ID',
          value: ''
        },
        RECAPTCHA_API_KEY: {
          key: 'RECAPTCHA_API_KEY',
          label: 'reCAPTCHA API Key',
          placeholder: 'Enterprise reCAPTCHA API Key',
          value: ''
        },
        RECAPTCHA_SITE_KEY: {
          key: 'RECAPTCHA_SITE_KEY',
          label: 'reCAPTCHA site Key',
          placeholder: 'Enterprise reCAPTCHA site Key',
          value: ''
        },
        PROPERTY_CACHE_EXPIRATION: {
          key: 'PROPERTY_CACHE_EXPIRATION',
          label: 'Property Cache Expiration',
          placeholder: 'Time in seconds to cache values in the lambdas',
          value: ''
        }
      }
    }
  },
  computed: {
    properties() {
      return this.supportedProperties
    },
    currentUserToken() {
      return this.$store.state.auth.userToken
    }
  },
  created() {
    this.fetchProperties()
  },
  methods: {
    fetchProperties() {
      dataAPI(this.currentUserToken)
        .getProperties()
        .then(properties => {
          for (let i = 0; i < properties.length; i++) {
            // remove last 2 characters "xx" from the siteKey key name
            const recaptchaSitekey = this.supportedProperties.RECAPTCHA_SITE_KEY.key
            if (properties[i].key === `${recaptchaSitekey}xx`) {
              properties[i].key = recaptchaSitekey
            }
            if (this.supportedProperties[properties[i].key]) {
              this.supportedProperties[properties[i].key].value = properties[i].value
            }
          }
        })
        .catch(response => {
          this.error = response.toString()
        })
    },
    updateProperty(property, value) {
      // don't send an update if the value didn't change
      if (property.value === value) {
        return
      }
      dataAPI(this.currentUserToken)
        .updateProperty({ key: property.key, value: value })
        .then(() => {
          this.supportedProperties[property.key].value = value
        })
        .catch(error => {
          console.log('error updating property ' + property.key, error)
        })
    },
    deleteProperty(property) {
      dataAPI(this.currentUserToken)
        .deleteProperty(property.key)
        .then(() => {
          this.supportedProperties[property.key].value = ''
        })
        .catch(error => {
          console.log('error deleting property ' + property.key, error)
        })
    }
  }
}
</script>
